import React, {useEffect, useMemo, useRef, useState,} from "react";
import IconSvg from "../IconSvg/IconSvg";
import notificationStore from "../../store/notificationStore";
import {NotificationItemBrowser, NotificationItemMobile,} from "./NotificationItem";
import {isMobile} from "react-device-detect";
import {isEmpty} from "lodash";
import {deleteNoti, readMarkNotiAll, readMarkNotiById} from "../../network/notiApi";
import {fetchCountNoti, fetchNotification} from "../../services/notiServices";
import {clsx} from "clsx";
import {formatDay} from "../../utils";
import Empty from "../Empty/Empty";
import {text} from "../../constants/text";
import Pagination from "../Pagination/Pagination";
import popupStore from "../../store/popupStore";

const NotificationComponent = () => {
  const {notifications, countNoti} = notificationStore();
  const {setPopupMobile} = popupStore();
  const [itemsPerPage] = useState(5); // Number of addresses displayed on each page
  const [currentPage, setCurrentPage] = useState(1);
  const [visibleGroups] = useState(5); // Số lượng group hiển thị
  const listRef = useRef(null); // Tham chiếu danh sách để tính chiều cao


  // Hàm group notifications theo ngày
  const groupNotificationsByDate = (notifications) => {
    const grouped = notifications?.reduce(
      (acc, noti) => {
        const date = formatDay(noti.createdAt)
        if (!acc[date]) {
          acc[date] = []
        }
        acc[date].push(noti)
        return acc
      }, {})
    return Object.entries(grouped).map(([date, items]) => ({
      date,
      items,
    }))
  }

  const groupedNotifications = useMemo(() => {
    if (!isEmpty(notifications?.items)) {
      return groupNotificationsByDate(notifications?.items)
    }
  }, [notifications])


  const handleMarkAllRead = async () => {
    await readMarkNotiAll().then(res => {
      if (res.success) {
        fetchNotification({
          page: currentPage,
          size: visibleGroups,
          type: 'seller_order'
        })
        fetchCountNoti({
          type: 'seller_order'
        })
      }
    })
  }

  const totalPages = Math.ceil(notifications?.total / itemsPerPage);

  const togglePopupAction = (id) => {
    return setPopupMobile({
      isOpenMobile: true,
      data: {
        height: 'h-[25%]',
        top: 'top-[75%]',
        children: <div className="flex flex-col px-4 pt-10">
          <div
            className="flex items-center p-2.5 gap-2.5"
            onClick={() => {
              handleReadNoti(id);
            }}
          >
            <IconSvg iconName="check-2" color="#111827" size={24}/>
            Đánh dấu đã đọc
          </div>
          <div
            className="flex items-center p-2.5 gap-2.5"
            onClick={() => {
              handleDeleteNoti(id)
            }}
          >
            <IconSvg iconName="trash" color="#111827" size={24}/>
            Xóa
          </div>
          <div
            className="flex items-center p-2.5 gap-2.5"
            onClick={() => setPopupMobile({})}
          >
            <IconSvg iconName="X" color="#111827" size={24}/>
            Hủy
          </div>
        </div>
      }
    })
  };

  const handleDeleteNoti = (id) => {
    deleteNoti(id).then(res => {
      if (res.success) {
        if (isMobile) setPopupMobile({})
        fetchNotification({
          page: currentPage,
          size: itemsPerPage,
          type: 'seller_order'
        })
        fetchCountNoti({
          type: 'seller_order'
        })
      }
    })
  }
  const handleReadNoti = (id) => {
    readMarkNotiById(id).then(res => {
      if (res.success) {
        if (isMobile) setPopupMobile({})
        fetchNotification({
          page: currentPage,
          size: itemsPerPage,
          type: 'seller_order'
        })
        fetchCountNoti({
          type: 'seller_order'
        })
      }
    })
  }
  // Process when changing pages
  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
    window.scrollTo({top: 0, behavior: "smooth"});
  };

  useEffect(() => {
    fetchNotification({page: currentPage, size: itemsPerPage, type: 'seller_order'})
  }, [currentPage]);

  if (isMobile) {
    return (
      <div
        ref={listRef}
        className="w-full flex flex-col items-center gap-5 font-inter animate-fadeIn"
      >
        <div className="w-full flex flex-col items-start px-4">
          <div className="w-full">
            {!isEmpty(groupedNotifications) ?
              <>
                {groupedNotifications.map(group => (
                  <div key={group?.date} className="w-full mb-4 bg-white rounded-xl overflow-hidden">
                    {/* Hiển thị ngày */}
                    <div className="w-full flex items-start p-2.5 font-normal text-sm text-black">
                      {group?.date}
                    </div>
                    {/* Hiển thị danh sách thông báo trong ngày */}
                    {group.items.map((notification) => (
                      <NotificationItemMobile
                        key={notification.id}
                        notification={notification}
                        togglePopupAction={() =>
                          togglePopupAction(notification.id)
                        }
                      />
                    ))}
                  </div>
                ))}
                {totalPages > 1 && (
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                )}
              </> :
              <Empty title={text.emptyNotification} minHeight={202}/>
            }
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className="w-full bg-white flex flex-col items-center gap-5 rounded-2xl font-inter animate-fadeIn shadow-md">
      {/* Header */}
      <div className="mt-7 w-full flex items-center justify-center">
        <IconSvg iconName="bell" color="#111827" size={24}/>
        <h1 className="text-black text-xl font-bold line-height-normal ">
          Thông báo
        </h1>
      </div>
      {/* Content*/}
      <div className="w-full flex flex-col items-start seft-stretch px-4">
        {/* markAllAsRead */}
        <div className="w-full flex items-center justify-end seft-stretch p-2.5 bg-green6 rounded-t-xl">
          <div
            className={clsx(
              'text-black text-sm font-normal line-height-normal',
              countNoti?.total === 0 ? 'cursor-not-allowed opacity-50' :
                'cursor-pointer'
            )}
            onClick={handleMarkAllRead}
          >
            <div>Đánh dấu đã đọc tất cả</div>
          </div>
        </div>

        {/* List Notification */}
        <div className="w-full">
          {!isEmpty(notifications?.items) ? notifications?.items.map((notification) => (
              <NotificationItemBrowser
                key={notification.id}
                notification={notification}
              />
            )) :
            <Empty title={text.emptyNotification}/>
          }
        </div>
      </div>

      {/* Footer */}
      <div className="flex justify-center items-center self-stretch p-4 gap-3.5">
        {totalPages > 1 && (
          <div className="pb-6 pt-3 bg-white rounded-b-2xl">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationComponent;
